
import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Grid, Card, CardContent, CardMedia, Typography, Chip, Button, Box, IconButton, Container, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";
import ShowTimeServices from "../../services/externalServices/TicketServices/showTimeServices";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { TextField } from '@mui/material';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
// Added the check Time

import moment from "moment"; // make sure you have moment.js installed

// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import BookingBreadcrumb from "../components/BookingBreadcrumb";



// const MovieDetails = () => {
//   const { movieId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { movie } = location.state;
//   const [movieDetails, setMovieDetails] = useState([]);
//   const [dateRange, setDateRange] = useState([]);
//   // const [selectedDate, setSelectedDate] = useState(null);

//   const [isLastShowActive, setIsLastShowActive] = useState(false);
//   const [enabledDateTimestamps, setEnabledDateTimestamps] = useState([]);



//   const [selectedDate, setSelectedDate] = useState(() => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     return today;
//   });


//   const [selectedTimes, setSelectedTimes] = useState({
//     theatreId: null,
//     time: null,
//   });



//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));


//   const isTicketAdmin = role === 'ticket-admin';
//   console.log('isTicketAdmin', isTicketAdmin);
//   const theatreName = accessList?.[0]; // assuming accessList contains theatre name


//   // const formatDateConsistently = (date) => {
//   //   if (!date) return null;

//   //   // Create a new date object to avoid modifying the original
//   //   const d = new Date(date);

//   //   // Handle timezone offset to get correct local date
//   //   const timezoneOffset = d.getTimezoneOffset() * 60000;
//   //   const localDate = new Date(d.getTime() - timezoneOffset);

//   //   return localDate.toISOString().split('T')[0]; // YYYY-MM-DD format
//   // };

//   const formatDateConsistently = (date) => {
//     if (!date) return null;
//     const d = new Date(date);
//     const pad = num => num.toString().padStart(2, '0');
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
//   };



//   // const fetchMovieShowDetails = async () => {
//   //   console.log('selectedDate=================================', formatDateConsistently(selectedDate));
//   //   try {
//   //     const formattedDate = formatDateConsistently(selectedDate); // 👉 '2025-07-09'



//   //     const details = await MovieServices.getTheatersAndShowTimings(movieId, theatreName, formattedDate);

//   //     console.log('In movie details Screeen ===============', details);
//   //     setMovieDetails(details);



//   //     const enabledDates = new Set();
//   //     details.forEach(detail => {
//   //       detail.theatreDetails?.forEach(theatre => {
//   //         theatre.shows?.forEach(show => {
//   //           show.enabledDates?.forEach(dateStr => {
//   //             const d = new Date(dateStr);
//   //             d.setHours(0, 0, 0, 0);
//   //             enabledDates.add(d.getTime());
//   //           });
//   //         });
//   //       });
//   //     });
//   //     setEnabledDateTimestamps(Array.from(enabledDates));


//   //     if (details.length > 0) {
//   //       const from = new Date(details[0].validityFrom);
//   //       const until = new Date(details[0].validityUntil);
//   //       setDateRange([from, until]);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching movie show details:", error);
//   //   }
//   // };






//   const fetchMovieShowDetails = async () => {
//     console.log('selectedDate=================================', formatDateConsistently(selectedDate));
//     try {
//       const formattedDate = formatDateConsistently(selectedDate);
//       const details = await MovieServices.getTheatersAndShowTimings(movieId, theatreName, formattedDate, true);

//       console.log('In movie details Screen ===============', details);
//       setMovieDetails(details);

//       const enabledDates = new Set();
//       details.forEach(detail => {
//         detail.theatreDetails?.forEach(theatre => {
//           theatre.shows?.forEach(show => {
//             show.enabledDates?.forEach(dateStr => {
//               const d = new Date(dateStr);
//               d.setHours(0, 0, 0, 0);
//               enabledDates.add(d.getTime());
//             });
//           });
//         });
//       });
//       setEnabledDateTimestamps(Array.from(enabledDates));

//       // FIX: Calculate date range from ALL details, not just the first one
//       if (details.length > 0) {
//         let earliestFrom = new Date(details[0].validityFrom);
//         let latestUntil = new Date(details[0].validityUntil);

//         // Find the overall min and max dates across all details
//         details.forEach(detail => {
//           const from = new Date(detail.validityFrom);
//           const until = new Date(detail.validityUntil);

//           if (from < earliestFrom) earliestFrom = from;
//           if (until > latestUntil) latestUntil = until;
//         });

//         setDateRange([earliestFrom, latestUntil]);
//       }
//     } catch (error) {
//       console.error("Error fetching movie show details:", error);
//     }
//   };




//   // useEffect(() => {
//   //   fetchMovieShowDetails();
//   // }, [movieId]);


//   useEffect(() => {
//     fetchMovieShowDetails();
//   }, [movieId, selectedDate]); // ✅ Fetch again when selectedDate changes



//   const generateDateArray = (startDate, endDate) => {
//     const dates = [];
//     const currentDate = new Date(startDate);
//     while (currentDate <= endDate) {
//       dates.push(new Date(currentDate));
//       currentDate.setDate(currentDate.getDate() + 1);
//     }
//     return dates;
//   };

//   const dateArray = dateRange.length === 2 ? generateDateArray(dateRange[0], dateRange[1]) : [];



//   const handleDateSelect = (date) => {
//     console.log('date in the handle function=========', date);

//     const normalizedDate = new Date(date);
//     normalizedDate.setHours(0, 0, 0, 0);
//     setSelectedDate(normalizedDate);

//     // Rest of your logic...
//   };







//   const handleTimeSelect = async (theatreId, maxTimeLimit, time, nameOfTheatre, code) => {
//     setSelectedTimes({ theatreId, time });

//     if (selectedDate) {
//       // const formattedDate = selectedDate.toISOString().split("T")[0].replace(/-/g, "/");
//       const formattedDate = selectedDate
//         .toLocaleDateString("en-CA")
//         .replace(/-/g, "/");


//       console.log("formattedDate", formattedDate);



//       const data = {
//         theatreId,
//         date: formattedDate,
//         time,
//         showtimeId: movieDetails[0].movieId,
//       };

//       // ⏱️ Time Comparison
//       const showTimeMoment = moment(`${formattedDate} ${time}`, "YYYY/MM/DD hh:mm A");
//       const currentMoment = moment();

//       if (showTimeMoment.isBefore(currentMoment)) {
//         const proceed = window.confirm("This showtime has already passed. Do you still want to continue?");
//         if (!proceed) return;
//       }

//       console.log("data in movieDetails", data);

//       const { date, showtimeId } = data;



//       try {
//         const seatLayout = await ScreenLayoutServices.getBookedScreenLayout(data);
//         console.log('before navigating to the screen layout', movie);
//         if (seatLayout.seatLayout) {
//           navigate("/bookedSeats", {
//             state: { seatLayout, date, time, theatreId, maxTimeLimit, showtimeId, movie, nameOfTheatre, code },
//           });
//         } else {
//           console.error("Error: Seat layout not found");
//         }
//       } catch (error) {
//         console.error("Error fetching booked screen layout:", error);
//       }
//     }
//   };




//   const handleEditClick = (showtimeId) => {
//     navigate(`/updateShowtimes/${showtimeId}`);
//   };

//   const handleDeleteClick = async (showtimeId, theatreId) => {
//     try {
//       await ShowTimeServices.deleteTheatreShowTime(showtimeId, theatreId);
//       fetchMovieShowDetails();
//     } catch (error) {
//       console.error("Error deleting theater:", error);
//     }
//   };


//   const isValidSelectedDate = (selectedDate, dateArray) => {
//     const normSel = new Date(selectedDate);
//     normSel.setHours(0, 0, 0, 0);

//     return dateArray.some(d => {
//       const normD = new Date(d);
//       normD.setHours(0, 0, 0, 0);
//       return normD.getTime() === normSel.getTime();
//     });
//   };




//   return (
//     <div className="min-h-screen mx-auto mb-4">
//       {/* Split Layout - Left (Poster/Details) and Right (Showtimes) */}
//       <div className="container mx-auto p-3 flex flex-col md:flex-row gap-6">
//         {/* Left Column - Poster and Movie Details */}
//         <div className="md:w-1/3">
//           <div className="flex flex-col gap-4 sticky top-4">
//             <div className="w-full h-40 rounded-lg shadow-md overflow-hidden">
//               <img
//                 src={movie.imageUrl}
//                 alt="poster"
//                 className="w-full h-full object-cover"
//               />
//             </div>
//             <div>
//               <h1 className="text-2xl font-semibold bg-gradient-to-r from-yellow-400 via-orange-400 to-orange-600 bg-clip-text text-transparent">
//                 {movie.name}
//               </h1>
//               {/* <div className="text-xs font-semibold text-gray-500 mb-2">
//               {movie.censorRating} • {movie.duration}
//             </div> */}
//               <div className="space-y-2">
//                 <div>
//                   <h3 className="text-xs font-semibold text-gray-500">GENRE</h3>
//                   <p className="text-sm">{movie.genre?.join(", ")}</p>
//                 </div>
//                 <div>
//                   <h3 className="text-xs font-semibold text-gray-500">LANGUAGES</h3>
//                   <p className="text-sm">{movie.movieLanguages?.join(", ")}</p>
//                 </div>
//                 <div>
//                   <h3 className="text-xs font-semibold text-gray-500">AVAILABLE UNTIL</h3>
//                   <p className="text-sm">
//                     {new Date(dateRange[1]).toLocaleDateString()}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Date and Showtimes */}
//         <div className="md:w-2/3">
//           {/* Date Selection */}
//           {dateArray.length > 0 && (
//             <div className="mb-6 bg-white p-4 rounded-lg shadow-sm">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Date
//               </label>
//               <div className="max-w-xs">
//                 <LocalizationProvider dateAdapter={AdapterDateFns}>
//                   <DatePicker
//                     format="dd/MM/yyyy"
//                     value={selectedDate || null}
//                     onChange={(newValue) => {
//                       if (newValue) {
//                         const normalizedDate = new Date(newValue);
//                         normalizedDate.setHours(0, 0, 0, 0);
//                         handleDateSelect(normalizedDate);
//                       }
//                     }}
//                     minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
//                     // shouldDisableDate={(date) => {
//                     //   const normalizedPickerDate = new Date(date);
//                     //   normalizedPickerDate.setHours(0, 0, 0, 0);
//                     //   return !dateArray.some(d => {
//                     //     const normalizedArrayDate = new Date(d);
//                     //     normalizedArrayDate.setHours(0, 0, 0, 0);
//                     //     return normalizedArrayDate.getTime() === normalizedPickerDate.getTime();
//                     //   });
//                     // }}


//                     shouldDisableDate={(date) => {
//                       const normalizedDate = new Date(date);
//                       normalizedDate.setHours(0, 0, 0, 0);
//                       return !enabledDateTimestamps.includes(normalizedDate.getTime());
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         size="small"
//                         className="bg-white"
//                       />
//                     )}
//                   />
//                 </LocalizationProvider>
//               </div>
//             </div>
//           )}

//           {/* Showtimes Section */}
//           <div className="space-y-4">










//             {isValidSelectedDate(selectedDate, dateArray) && (
//               <>
//                 {movieDetails
//                   // First filter: Only include theater groups that have valid theaters
//                   // .filter(detail => detail.theatreDetails?.length > 0)
//                   // // Flatten all theater details
//                   // .flatMap(detail => detail.theatreDetails)
//                   // // Filter theaters that have shows for the selected date
//                   // .filter(theater => {
//                   //   const formattedSelectedDate = formatDateConsistently(selectedDate);

//                   //   // Check if any show has this date in enabledDates
//                   //   const hasShowForDate = theater.shows?.some(show => 
//                   //     show.enabledDates?.includes(formattedSelectedDate)
//                   //   );

//                   //   return hasShowForDate;
//                   // })



//                   .flatMap(detail => detail.theatreDetails)
//                   // Filter theaters that have shows for the selected date
//                   .filter(theater => {
//                     const formattedSelectedDate = formatDateConsistently(selectedDate);

//                     // Check if any show has this date in enabledDates
//                     return theater.shows?.some(show =>
//                       show.enabledDates?.includes(formattedSelectedDate)
//                     );
//                   })
//                   // .filter(detail => {
//                   //   const detailFrom = new Date(detail.validityFrom);
//                   //   const detailUntil = new Date(detail.validityUntil);
//                   //   const selected = new Date(selectedDate);
//                   //   selected.setHours(0, 0, 0, 0);

//                   //   // Check if selected date falls within this detail's validity range
//                   //   return selected >= detailFrom && selected <= detailUntil;
//                   // })
//                   // // Flatten all theater details
//                   // .flatMap(detail => detail.theatreDetails)
//                   // // Filter theaters that have shows for the selected date
//                   // .filter(theater => {
//                   //   const formattedSelectedDate = formatDateConsistently(selectedDate);

//                   //   // Check if any show has this date in enabledDates
//                   //   return theater.shows?.some(show => 
//                   //     show.enabledDates?.includes(formattedSelectedDate)
//                   //   );
//                   // })




//                   // Render each qualifying theater
//                   .map((theaterDetail, index) => {
//                     const parseTimeToDate = (timeStr) => {
//                       const now = new Date();
//                       const [hours, minutesPart] = timeStr.split(":");
//                       const [minutes, meridiem] = minutesPart.trim().split(" ");
//                       let hour24 = parseInt(hours);
//                       if (meridiem === "PM" && hour24 !== 12) hour24 += 12;
//                       if (meridiem === "AM" && hour24 === 12) hour24 = 0;
//                       const date = new Date(now);
//                       date.setHours(hour24, parseInt(minutes), 0, 0);
//                       return date;
//                     };

//                     const now = new Date();
//                     const today = new Date(now);
//                     today.setHours(0, 0, 0, 0);

//                     // Get shows for selected date
//                     const formattedSelectedDate = formatDateConsistently(selectedDate);
//                     const filteredShows = theaterDetail.shows.filter(show =>
//                       show.enabledDates.includes(formattedSelectedDate)
//                     );

//                     // Create parsed times for rendering
//                     const parsedTimes = filteredShows.flatMap(show =>
//                       show.time ? [{
//                         label: show.time,
//                         date: parseTimeToDate(show.time),
//                         language: show.language,
//                         format: show.format
//                       }] : []
//                     ).sort((a, b) => a.date - b.date);

//                     return (
//                       <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
//                         {/* Theater header */}
//                         <div className="p-4 border-b border-gray-100 flex justify-between items-center">
//                           <div>
//                             <h3 className="text-lg font-semibold">
//                               {theaterDetail.theatreId.name}
//                             </h3>
//                             <p className="text-sm text-gray-500">
//                               {theaterDetail.theatreId.city} • {theaterDetail.theatreId.location.address}
//                             </p>
//                           </div>
//                           {role === 'super-admin' && (
//                             <div className="flex gap-2">
//                               <button
//                                 onClick={() => handleEditClick(theaterDetail._id)}
//                                 className="p-1 hover:bg-blue-100 rounded text-blue-600"
//                               >
//                                 <FiEdit size={16} />
//                               </button>
//                               <button
//                                 onClick={() => handleDeleteClick(theaterDetail._id, theaterDetail.theatreId._id)}
//                                 className="p-1 hover:bg-red-100 rounded text-red-600"
//                               >
//                                 <FiTrash2 size={16} />
//                               </button>
//                             </div>
//                           )}
//                         </div>

//                         {/* Showtimes */}
//                         {/* <div className="p-4">
//               <h4 className="text-sm font-semibold text-gray-500 mb-3">
//                 {theaterDetail.shows[0]?.format} • {theaterDetail.shows[0]?.language}
//               </h4>
//               <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                 {parsedTimes.length > 0 ? (
//                   parsedTimes.map(({ label, date }, ti) => {
//                     // Time availability logic (kept from your original code)
//                     const yesterday = new Date(today);
//                     yesterday.setDate(today.getDate() - 1);

//                     const cutoff = new Date(today);
//                     cutoff.setHours(2, 0, 0, 0);

//                     const selected = selectedDate ? new Date(selectedDate) : null;
//                     if (selected) selected.setHours(0, 0, 0, 0);

//                     const isToday = selected && selected.getTime() === today.getTime();
//                     const isYesterday = selected && selected.getTime() === yesterday.getTime();
//                     const isFutureDate = selected && selected > today;

//                     const showDate = new Date(selected || today);
//                     const [time, period] = label.split(' ');
//                     let [hours, minutes] = time.split(':').map(Number);

//                     if (period === 'PM' && hours !== 12) hours += 12;
//                     if (period === 'AM' && hours === 12) hours = 0;

//                     showDate.setHours(hours, minutes, 0, 0);

//                     let isDisabled = false;

//                     if (isToday) {
//                       const pastShows = parsedTimes.filter(({ date }) => date <= now);
//                       const currentShow = pastShows[pastShows.length - 1];
//                       const nextShow = parsedTimes.find(({ date }) => date > (currentShow?.date || new Date(0)));

//                       isDisabled = !(
//                         (currentShow && showDate.getTime() === currentShow.date.getTime()) ||
//                         showDate > now
//                       );

//                       if (currentShow && !nextShow && showDate.getTime() === currentShow.date.getTime()) {
//                         isDisabled = false;
//                       }
//                     } else if (isYesterday) {
//                       if (now < cutoff) {
//                         const allShows = parsedTimes.map(({ label }) => {
//                           const [t, p] = label.split(' ');
//                           let [h, m] = t.split(':').map(Number);
//                           if (p === 'PM' && h !== 12) h += 12;
//                           if (p === 'AM' && h === 12) h = 0;
//                           const d = new Date(yesterday);
//                           d.setHours(h, m, 0, 0);
//                           return { label, date: d };
//                         });

//                         const pastShows = allShows.filter(({ date }) => date <= now);
//                         const latestPastShow = pastShows[pastShows.length - 1];

//                         isDisabled = !(latestPastShow && showDate.getTime() === latestPastShow.date.getTime());
//                       } else {
//                         isDisabled = true;
//                       }
//                     } else if (isFutureDate) {
//                       isDisabled = false;
//                     } else {
//                       isDisabled = true;
//                     }

//                     return (
//                       <button
//                         key={ti}
//                         disabled={isDisabled}
//                         onClick={() => !isDisabled && handleTimeSelect(
//                           theaterDetail.theatreId._id,
//                           theaterDetail.theatreId.maxTimeLimit,
//                           label,
//                           theaterDetail.theatreId.name,
//                           theaterDetail.theatreId.code
//                         )}
//                         className={`py-2 px-3 rounded text-sm border-1 border-green-500 font-medium transition-colors ${
//                           selectedTimes.theatreId === theaterDetail.theatreId._id &&
//                           selectedTimes.time === label
//                             ? "bg-green-500 text-white"
//                             : "bg-gray-100 text-gray-800 hover:bg-gray-200"
//                         } ${
//                           isDisabled
//                             ? "opacity-50 cursor-not-allowed"
//                             : "cursor-pointer"
//                         }`}
//                       >
//                         {label}
//                       </button>
//                     );
//                   })
//                 ) : (
//                   <p className="text-sm text-gray-500 col-span-full">
//                     No shows available for this date
//                   </p>
//                 )}
//               </div>
//             </div> */}



//                         <div className="p-4">
//                           <h4 className="text-sm font-semibold text-gray-500 mb-3">Show Times</h4>
//                           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                             {parsedTimes.length > 0 ? (
//                               parsedTimes.map(({ label, date, language, format }, ti) => {
//                                 // Your existing time availability logic stays exactly the same
//                                 const yesterday = new Date(today);
//                                 yesterday.setDate(today.getDate() - 1);

//                                 const cutoff = new Date(today);
//                                 cutoff.setHours(2, 0, 0, 0);

//                                 const selected = selectedDate ? new Date(selectedDate) : null;
//                                 if (selected) selected.setHours(0, 0, 0, 0);

//                                 const isToday = selected && selected.getTime() === today.getTime();
//                                 const isYesterday = selected && selected.getTime() === yesterday.getTime();
//                                 const isFutureDate = selected && selected > today;

//                                 const showDate = new Date(selected || today);
//                                 const [time, period] = label.split(' ');
//                                 let [hours, minutes] = time.split(':').map(Number);

//                                 if (period === 'PM' && hours !== 12) hours += 12;
//                                 if (period === 'AM' && hours === 12) hours = 0;

//                                 showDate.setHours(hours, minutes, 0, 0);

//                                 let isDisabled = false;

//                                 if (isToday) {
//                                   const pastShows = parsedTimes.filter(({ date }) => date <= now);
//                                   const currentShow = pastShows[pastShows.length - 1];
//                                   const nextShow = parsedTimes.find(({ date }) => date > (currentShow?.date || new Date(0)));

//                                   isDisabled = !(
//                                     (currentShow && showDate.getTime() === currentShow.date.getTime()) ||
//                                     showDate > now
//                                   );

//                                   if (currentShow && !nextShow && showDate.getTime() === currentShow.date.getTime()) {
//                                     isDisabled = false;
//                                   }
//                                 } else if (isYesterday) {
//                                   if (now < cutoff) {
//                                     const allShows = parsedTimes.map(({ label }) => {
//                                       const [t, p] = label.split(' ');
//                                       let [h, m] = t.split(':').map(Number);
//                                       if (p === 'PM' && h !== 12) h += 12;
//                                       if (p === 'AM' && h === 12) h = 0;
//                                       const d = new Date(yesterday);
//                                       d.setHours(h, m, 0, 0);
//                                       return { label, date: d };
//                                     });

//                                     const pastShows = allShows.filter(({ date }) => date <= now);
//                                     const latestPastShow = pastShows[pastShows.length - 1];

//                                     isDisabled = !(latestPastShow && showDate.getTime() === latestPastShow.date.getTime());
//                                   } else {
//                                     isDisabled = true;
//                                   }
//                                 } else if (isFutureDate) {
//                                   isDisabled = false;
//                                 } else {
//                                   isDisabled = true;
//                                 }

//                                 return (
//                                   <button
//                                     key={ti}
//                                     disabled={isDisabled}
//                                     onClick={() => !isDisabled && handleTimeSelect(
//                                       theaterDetail.theatreId._id,
//                                       theaterDetail.theatreId.maxTimeLimit,
//                                       label,
//                                       theaterDetail.theatreId.name,
//                                       theaterDetail.theatreId.code
//                                     )}
//                                     className={`py-2 px-3 rounded text-sm border-1 border-green-500 font-medium transition-colors ${selectedTimes.theatreId === theaterDetail.theatreId._id &&
//                                         selectedTimes.time === label
//                                         ? "bg-green-500 text-white"
//                                         : "bg-gray-100 text-gray-800 hover:bg-gray-200"
//                                       } ${isDisabled
//                                         ? "opacity-50 cursor-not-allowed"
//                                         : "cursor-pointer"
//                                       }`}
//                                   >
//                                     <div className="font-semibold">{label}</div>
//                                     <div className="text-xs opacity-75">{format} • {language}</div>
//                                   </button>
//                                 );
//                               })
//                             ) : (
//                               <p className="text-sm text-gray-500 col-span-full">
//                                 No shows available for this date
//                               </p>
//                             )}
//                           </div>
//                         </div>



//                       </div>
//                     );
//                   })}
//               </>
//             )}


//           </div>
//         </div>
//       </div>
//     </div>
//   );




// };













const MovieDetails = () => {
  const { movieId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { movie } = location.state;
  const [movieDetails, setMovieDetails] = useState([]);
  const [rawMovieDetails, setRawMovieDetails] = useState([]); // ✅ Cache raw data
  const [dateRange, setDateRange] = useState([]);
  const [isLastShowActive, setIsLastShowActive] = useState(false);
  const [enabledDateTimestamps, setEnabledDateTimestamps] = useState([]);

  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  });

  const [selectedTimes, setSelectedTimes] = useState({
    theatreId: null,
    time: null,
  });

  const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
  const isTicketAdmin = role === 'ticket-admin';
  console.log('isTicketAdmin', isTicketAdmin);
  const theatreName = accessList?.[0];

  const formatDateConsistently = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const pad = num => num.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  // ✅ Updated fetchMovieShowDetails with caching
  const fetchMovieShowDetails = async (shouldRefetch = true) => {
    // Only fetch if we don't have cached data or explicitly need to refetch
    if (!shouldRefetch && rawMovieDetails.length > 0) {
      filterShowsForSelectedDate();
      return;
    }

    console.log('selectedDate=================================', formatDateConsistently(selectedDate));
    try {
      const formattedDate = formatDateConsistently(selectedDate);
      const details = await MovieServices.getTheatersAndShowTimings(movieId, theatreName, formattedDate, true);

      console.log('In movie details Screen ===============', details);
      
      // ✅ Cache the raw response
      setRawMovieDetails(details);
      setMovieDetails(details);

      // ✅ FIXED: Use availableDates if available, fallback to individual show enabledDates
      const enabledDates = new Set();
      details.forEach(detail => {
        detail.theatreDetails?.forEach(theatre => {
          if (theatre.availableDates) {
            // ✅ Use pre-computed availableDates
            theatre.availableDates.forEach(dateStr => {
              const d = new Date(dateStr);
              d.setHours(0, 0, 0, 0);
              enabledDates.add(d.getTime());
            });
          } else {
            // Fallback to individual show enabledDates
            const showsToCheck = theatre.allShows || theatre.shows;
            showsToCheck?.forEach(show => {
              show.enabledDates?.forEach(dateStr => {
                const d = new Date(dateStr);
                d.setHours(0, 0, 0, 0);
                enabledDates.add(d.getTime());
              });
            });
          }
        });
      });
      setEnabledDateTimestamps(Array.from(enabledDates));

      // Calculate date range from ALL details
      if (details.length > 0) {
        let earliestFrom = new Date(details[0].validityFrom);
        let latestUntil = new Date(details[0].validityUntil);

        details.forEach(detail => {
          const from = new Date(detail.validityFrom);
          const until = new Date(detail.validityUntil);
          if (from < earliestFrom) earliestFrom = from;
          if (until > latestUntil) latestUntil = until;
        });

        setDateRange([earliestFrom, latestUntil]);
      }
    } catch (error) {
      console.error("Error fetching movie show details:", error);
    }
  };

  // ✅ Helper function to filter cached data
  const filterShowsForSelectedDate = () => {
    const formattedSelectedDate = formatDateConsistently(selectedDate);
    
    const filteredDetails = rawMovieDetails.map(detail => ({
      ...detail,
      theatreDetails: detail.theatreDetails.filter(theatre => {
        // ✅ Use allShows if available, fallback to shows
        const showsToCheck = theatre.allShows || theatre.shows;
        return showsToCheck?.some(show =>
          show.enabledDates?.includes(formattedSelectedDate)
        );
      })
    })).filter(detail => detail.theatreDetails.length > 0);

    setMovieDetails(filteredDetails);
  };

  // ✅ Updated useEffect - only fetch on initial load
  useEffect(() => {
    if (!movieId) return;
    fetchMovieShowDetails(true);
  }, [movieId]);

  // ✅ Handle date changes without refetching
  useEffect(() => {
    if (rawMovieDetails.length > 0) {
      filterShowsForSelectedDate();
    }
  }, [selectedDate]);

  const generateDateArray = (startDate, endDate) => {
    const dates = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const dateArray = dateRange.length === 2 ? generateDateArray(dateRange[0], dateRange[1]) : [];

  // ✅ Updated handleDateSelect to work with cached data
  const handleDateSelect = (date) => {
    console.log('date in the handle function=========', date);

    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    setSelectedDate(normalizedDate);

    // ✅ Filter cached data instead of refetching
    if (rawMovieDetails.length > 0) {
      filterShowsForSelectedDate();
    }
  };

  const handleTimeSelect = async (theatreId, maxTimeLimit, time, nameOfTheatre, code,isSectionLayout) => {
    setSelectedTimes({ theatreId, time });

    if (selectedDate) {
      const formattedDate = selectedDate
        .toLocaleDateString("en-CA")
        .replace(/-/g, "/");

      console.log("isSectionLayout", isSectionLayout);

      const data = {
        theatreId,
        date: formattedDate,
        time,
        showtimeId: movieDetails[0].movieId,
      };

      // ⏱️ Time Comparison
      const showTimeMoment = moment(`${formattedDate} ${time}`, "YYYY/MM/DD hh:mm A");
      const currentMoment = moment();

      if (showTimeMoment.isBefore(currentMoment)) {
        const proceed = window.confirm("This showtime has already passed. Do you still want to continue?");
        if (!proceed) return;
      }

      console.log("data in movieDetails", data);
      const { date, showtimeId } = data;

      try {
        const seatLayout = await ScreenLayoutServices.getBookedScreenLayout(data);
        console.log('before navigating to the screen layout', movie);
        if (seatLayout.seatLayout) {
          navigate("/bookedSeats", {
            state: { seatLayout, date, time, theatreId, maxTimeLimit, showtimeId, movie, nameOfTheatre, code,isSectionLayout },
          });
        } else {
          console.error("Error: Seat layout not found");
        }
      } catch (error) {
        console.error("Error fetching booked screen layout:", error);
      }
    }
  };

  const handleEditClick = (showtimeId) => {
    navigate(`/updateShowtimes/${showtimeId}`);
  };

  const handleDeleteClick = async (showtimeId, theatreId) => {
    try {
      await ShowTimeServices.deleteTheatreShowTime(showtimeId, theatreId);
      fetchMovieShowDetails(true); // ✅ Force refetch after delete
    } catch (error) {
      console.error("Error deleting theater:", error);
    }
  };

  const isValidSelectedDate = (selectedDate, dateArray) => {
    const normSel = new Date(selectedDate);
    normSel.setHours(0, 0, 0, 0);

    return dateArray.some(d => {
      const normD = new Date(d);
      normD.setHours(0, 0, 0, 0);
      return normD.getTime() === normSel.getTime();
    });
  };

  return (
    <div className="min-h-screen mx-auto mb-4">
      <div className="container mx-auto p-3">
        <BookingBreadcrumb currentStep="details" />
      </div>
      <div className="container mx-auto p-3 flex flex-col md:flex-row gap-6">
        {/* Left Column - Poster and Movie Details */}
        <div className="md:w-1/3">
          <div className="flex flex-col gap-4 sticky top-4">
            <div className="w-full h-40 rounded-lg shadow-md overflow-hidden">
              <img
                src={movie.imageUrl}
                alt="poster"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h1 className="text-2xl font-semibold bg-gradient-to-r from-yellow-400 via-orange-400 to-orange-600 bg-clip-text text-transparent">
                {movie.name}
              </h1>
              <div className="space-y-2">
                <div>
                  <h3 className="text-xs font-semibold text-gray-500">GENRE</h3>
                  <p className="text-sm">{movie.genre?.join(", ")}</p>
                </div>
                <div>
                  <h3 className="text-xs font-semibold text-gray-500">LANGUAGES</h3>
                  <p className="text-sm">{movie.movieLanguages?.join(", ")}</p>
                </div>
                <div>
                  <h3 className="text-xs font-semibold text-gray-500">AVAILABLE UNTIL</h3>
                  <p className="text-sm">
                    {new Date(dateRange[1]).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Date and Showtimes */}
        <div className="md:w-2/3">
          {/* Date Selection */}
          {dateArray.length > 0 && (
            <div className="mb-6 bg-white p-4 rounded-lg shadow-sm">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Date
              </label>
              <div className="max-w-xs">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd/MM/yyyy"
                    value={selectedDate || null}
                    onChange={(newValue) => {
                      if (newValue) {
                        const normalizedDate = new Date(newValue);
                        normalizedDate.setHours(0, 0, 0, 0);
                        handleDateSelect(normalizedDate);
                      }
                    }}
                    minDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                    shouldDisableDate={(date) => {
                      const normalizedDate = new Date(date);
                      normalizedDate.setHours(0, 0, 0, 0);
                      return !enabledDateTimestamps.includes(normalizedDate.getTime());
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        className="bg-white"
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>
          )}

          {/* Showtimes Section */}
          <div className="space-y-4">
            {isValidSelectedDate(selectedDate, dateArray) && (
              <>
                {movieDetails
                  .flatMap(detail => detail.theatreDetails)
                  .filter(theater => {
                    const formattedSelectedDate = formatDateConsistently(selectedDate);
                    // ✅ FIXED: Use allShows if available, fallback to shows
                    const showsToCheck = theater.allShows || theater.shows;
                    return showsToCheck?.some(show =>
                      show.enabledDates?.includes(formattedSelectedDate)
                    );
                  })
                  .map((theaterDetail, index) => {
                    const parseTimeToDate = (timeStr) => {
                      const now = new Date();
                      const [hours, minutesPart] = timeStr.split(":");
                      const [minutes, meridiem] = minutesPart.trim().split(" ");
                      let hour24 = parseInt(hours);
                      if (meridiem === "PM" && hour24 !== 12) hour24 += 12;
                      if (meridiem === "AM" && hour24 === 12) hour24 = 0;
                      const date = new Date(now);
                      date.setHours(hour24, parseInt(minutes), 0, 0);
                      return date;
                    };

                    const now = new Date();
                    const today = new Date(now);
                    today.setHours(0, 0, 0, 0);

                    // ✅ FIXED: Get shows from allShows or shows for selected date
                    const formattedSelectedDate = formatDateConsistently(selectedDate);
                    const showsToFilter = theaterDetail.allShows || theaterDetail.shows;
                    const filteredShows = showsToFilter.filter(show =>
                      show.enabledDates.includes(formattedSelectedDate)
                    );

                    // Create parsed times for rendering
                    const parsedTimes = filteredShows.flatMap(show =>
                      show.time ? [{
                        label: show.time,
                        date: parseTimeToDate(show.time),
                        language: show.language,
                        format: show.format
                      }] : []
                    ).sort((a, b) => a.date - b.date);

                    return (
                      <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
                        {/* Theater header */}
                        <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                          <div>
                            <h3 className="text-lg font-semibold">
                              {theaterDetail.theatreId.name}
                            </h3>
                            <p className="text-sm text-gray-500">
                              {theaterDetail.theatreId.city} • {theaterDetail.theatreId.location.address}
                            </p>
                          </div>
                          {role === 'super-admin' && (
                            <div className="flex gap-2">
                              <button
                                onClick={() => handleEditClick(theaterDetail._id)}
                                className="p-1 hover:bg-blue-100 rounded text-blue-600"
                              >
                                <FiEdit size={16} />
                              </button>
                              <button
                                onClick={() => handleDeleteClick(theaterDetail._id, theaterDetail.theatreId._id)}
                                className="p-1 hover:bg-red-100 rounded text-red-600"
                              >
                                <FiTrash2 size={16} />
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Showtimes */}
                        <div className="p-4">
                          <h4 className="text-sm font-semibold text-gray-500 mb-3">Show Times</h4>
                          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            {parsedTimes.length > 0 ? (
                              parsedTimes.map(({ label, date, language, format }, ti) => {
                                // Your existing time availability logic stays exactly the same
                                const yesterday = new Date(today);
                                yesterday.setDate(today.getDate() - 1);

                                const cutoff = new Date(today);
                                cutoff.setHours(2, 0, 0, 0);

                                const selected = selectedDate ? new Date(selectedDate) : null;
                                if (selected) selected.setHours(0, 0, 0, 0);

                                const isToday = selected && selected.getTime() === today.getTime();
                                const isYesterday = selected && selected.getTime() === yesterday.getTime();
                                const isFutureDate = selected && selected > today;

                                const showDate = new Date(selected || today);
                                const [time, period] = label.split(' ');
                                let [hours, minutes] = time.split(':').map(Number);

                                if (period === 'PM' && hours !== 12) hours += 12;
                                if (period === 'AM' && hours === 12) hours = 0;

                                showDate.setHours(hours, minutes, 0, 0);

                                let isDisabled = false;

                                if (isToday) {
                                  const pastShows = parsedTimes.filter(({ date }) => date <= now);
                                  const currentShow = pastShows[pastShows.length - 1];
                                  const nextShow = parsedTimes.find(({ date }) => date > (currentShow?.date || new Date(0)));

                                  isDisabled = !(
                                    (currentShow && showDate.getTime() === currentShow.date.getTime()) ||
                                    showDate > now
                                  );

                                  if (currentShow && !nextShow && showDate.getTime() === currentShow.date.getTime()) {
                                    isDisabled = false;
                                  }
                                } else if (isYesterday) {
                                  if (now < cutoff) {
                                    const allShows = parsedTimes.map(({ label }) => {
                                      const [t, p] = label.split(' ');
                                      let [h, m] = t.split(':').map(Number);
                                      if (p === 'PM' && h !== 12) h += 12;
                                      if (p === 'AM' && h === 12) h = 0;
                                      const d = new Date(yesterday);
                                      d.setHours(h, m, 0, 0);
                                      return { label, date: d };
                                    });

                                    const pastShows = allShows.filter(({ date }) => date <= now);
                                    const latestPastShow = pastShows[pastShows.length - 1];

                                    isDisabled = !(latestPastShow && showDate.getTime() === latestPastShow.date.getTime());
                                  } else {
                                    isDisabled = true;
                                  }
                                } else if (isFutureDate) {
                                  isDisabled = false;
                                } else {
                                  isDisabled = true;
                                }

                                return (
                                  <button
                                    key={ti}
                                    disabled={isDisabled}
                                    onClick={() => !isDisabled && handleTimeSelect(
                                      theaterDetail.theatreId._id,
                                      theaterDetail.theatreId.maxTimeLimit,
                                      label,
                                      theaterDetail.theatreId.name,
                                      theaterDetail.theatreId.code,
                                      theaterDetail?.theatreId?.isSectionLayout
                                    )}
                                    className={`py-2 px-3 rounded text-sm border-1 border-green-500 font-medium transition-colors ${selectedTimes.theatreId === theaterDetail.theatreId._id &&
                                        selectedTimes.time === label
                                        ? "bg-green-500 text-white"
                                        : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                                      } ${isDisabled
                                        ? "opacity-50 cursor-not-allowed"
                                        : "cursor-pointer"
                                      }`}
                                  >
                                    <div className="font-semibold">{label}</div>
                                    <div className="text-xs opacity-75">{format} • {language}</div>
                                  </button>
                                );
                              })
                            ) : (
                              <p className="text-sm text-gray-500 col-span-full">
                                No shows available for this date
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


export default MovieDetails;
